import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d45ab40a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-bar" }
const _hoisted_2 = { class: "bottom-bar-inter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "bottom-bar",
  class: "bottom-bar-active-block"
}, null, -1))
const _hoisted_4 = { class: "bottom-bar-links" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bx-code-alt" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-user-circle" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-data" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRoute('#code'))),
          id: "codeLink",
          class: _normalizeClass([{ 'bottom-bar-active': _ctx.route === '#code' }, "bottom-bar-icon"])
        }, _hoisted_6, 2),
        _createElementVNode("div", {
          id: "userLink",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeRoute('#user'))),
          class: _normalizeClass([{ 'bottom-bar-active': _ctx.route === '#user' }, "bottom-bar-icon"])
        }, _hoisted_8, 2),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeRoute('#data'))),
          id: "dataLink",
          class: _normalizeClass([{ 'bottom-bar-active': _ctx.route === '#data' }, "bottom-bar-icon"])
        }, _hoisted_10, 2)
      ])
    ])
  ]))
}